/**
 * @desc 领用单导出
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.lendMaster.lendOutExcel.Params, options?: any) {
  return updateResponse(
    http(URL + `/lendMaster/lendOutExcel`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
